import { render } from "./WorkflowArray.vue?vue&type=template&id=27c08205&scoped=true&ts=true"
import script from "./WorkflowArray.vue?vue&type=script&lang=ts"
export * from "./WorkflowArray.vue?vue&type=script&lang=ts"

import "./WorkflowArray.vue?vue&type=style&index=0&id=27c08205&lang=scss&scoped=true"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27c08205"]])

export default __exports__